import { render, staticRenderFns } from "./c-grid-btns.vue?vue&type=template&id=1134c1b5&"
import script from "./c-grid-btns.vue?vue&type=script&lang=js&"
export * from "./c-grid-btns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports